import { useState } from 'react';

import { useMatchesStore } from '@/entities/match';
import { createPrediction, usePredictionsStore } from '@/entities/prediction';
import type { CreatePredictionPayload } from '@/entities/prediction';
import { useSessionStore } from '@/entities/session';
import { toPlayerMessage } from '@/shared/api';
import { hapticNotification } from '@/shared/lib/telegram';

interface CreatePredictionApi {
  submit: (payload: CreatePredictionPayload) => Promise<boolean>;
  isSubmitting: boolean;
  error: string | null;
}

/**
 * Подтверждение Прогноза.
 *
 * Клиент не решает, можно ли ставить: приём, наличие Фанкоинов и дубль типа
 * проверяет сервер до списания. Наше дело — показать 409 текстом.
 */
export function useCreatePrediction(): CreatePredictionApi {
  const applyCreated = usePredictionsStore((state) => state.applyCreated);
  const applyPrediction = useMatchesStore((state) => state.applyPrediction);
  const applyFuncoinBalance = useSessionStore(
    (state) => state.applyFuncoinBalance,
  );
  const [isSubmitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (payload: CreatePredictionPayload): Promise<boolean> => {
    setSubmitting(true);
    setError(null);

    try {
      const { prediction, funcoinBalance } = await createPrediction(payload);
      applyCreated(prediction);
      // Баланс живёт в сессии — там же, где его показывает шапка
      applyFuncoinBalance(funcoinBalance);
      applyPrediction(payload.matchId, prediction);
      hapticNotification('success');
      return true;
    } catch (cause) {
      hapticNotification('error');
      setError(toPlayerMessage(cause));
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  return { submit, isSubmitting, error };
}
